<script setup>
import {ref, computed} from "vue";

const props = defineProps(['value', 'rawValue', 'options', 'changed']);
const emit = defineEmits(['input']);

const editMode = ref(false);

const model = computed({
    get: () => props.value,
    set: (value) => {
        emit('input', value);
        emit('changed');
    }
});
</script>

<template>
    <div class="custom-value">
        <select
            v-if="editMode"
            v-model="model"
            class="form-input"
            v-click-outside="() => editMode = false"
        >
            <option value=""></option>
            <option v-for="option in options" :key="option" :value="option">
                {{option}}
            </option>
        </select>

        <div v-else @click.stop="editMode = true" style="min-height: 20px">
            <span v-if="!model && rawValue && !options.includes(rawValue)" class="option-error">
                {{rawValue}}
            </span>

            <span v-else>
                {{model}}
            </span>
        </div>
    </div>
</template>

<style scoped>
    .option-error {
        color: #dc3545;
    }

    /*.custom-value {
        padding: 5px;
        border-radius: 5px;
    }

    .custom-value:hover {
        background-color: #f8f9fa;
        border-radius: 5px;
        cursor: pointer;
    }*/
</style>
